namespace GeniuzPOS.RefundReasonReport {

    @Serenity.Decorators.registerClass()
    export class ReportRefundReasonSumBillDtEditor extends Serenity.Extensions.GridEditorBase<ReportRefundReasonSumBillDtRow> {
        protected getColumnsKey() { return "RefundReasonReport.ReportRefundReasonSumBillDt"; }
        protected getDialogType() { return ReportRefundReasonSumBillDtDialog; }
        protected getLocalTextPrefix() { return ReportRefundReasonSumBillDtRow.localTextPrefix; }
        protected getService() { return ReportRefundReasonSumBillDtService.baseUrl; }
        
        public qnNo: number;

        public myPassValue: string;        
        

        constructor(container: JQuery) {
            super(container);
        
        }      

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
           
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
            //     grid: this,
            //     service: ReportRefundReasonSumBillDtService.baseUrl + '/ListExcel',
            //     onViewSubmit: () => this.onViewSubmit(),
            //     separator: true
            // }));



            return buttons;
        }
    
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            return opt;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }

        protected usePager() {
            return false;
        }

    }
}

